import Component from "@lib/Component.js";
import YouTubePlayer from "youtube-player";
import { observeOnce } from "../lib/helpers/observer";
import { addClass, addEvent } from "@qneyraud/q-utils/umd/q-utils";

export default class Video extends Component {
  init() {
    super.init();
    this.bindMethods();

    console.info(this.datas);
    if (this.datas.youtubeId) {
      this.player = YouTubePlayer(this.refs.player, {
        width: this.refs.player.clientWidth,
        height: this.refs.player.clientHeight,
        playerVars: {
          autoplay: 0,
          color: "white",
          controls: 0,
          iv_load_policy: 3,
          modestbranding: 1,
          rel: 0,
          showinfo: 0
        }
      });
    }

    this.initEvents();
  }

  bindMethods() {
    this.loadVideo = this.loadVideo.bind(this);
    this.onPlayButtonClick = this.onPlayButtonClick.bind(this);
  }

  initEvents() {
    addEvent(this.refs["play-button"], "click", this.onPlayButtonClick);
  }

  onEnterCompleted() {
    super.onEnterCompleted();

    observeOnce(this.el, {
      offsetTop: -100
    }).on("enter", this.loadVideo);
  }

  loadVideo() {
    if (this.player) {
      this.player.loadVideoById(this.datas.youtubeId).then(() => {
        this.player.stopVideo();
      });
    }
  }

  onPlayButtonClick() {
    if (this.player) this.player.playVideo();

    if (this.datas.ubicast) {
      this.refs.player.innerHTML = `<iframe class="modal-player" src="${this.datas.ubicast}" allowfullscreen="allowfullscreen" allow="autoplay"></iframe>`;
    }

    addClass(this.el, "playing");
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Video.js